<template>
	<div class="contacts">
		<!-- 头部组件 -->
		<div style="background: #fff">
			<div class="w"><SecondHead activeIndex="1" textColor="#333" color="#333"></SecondHead></div>
		</div>
		<!-- 主页内容 -->
		<div class="contacts_box" v-if="contant">
			<div class="contacts_childOne">
				<div class="contant">
					<div class="bor"></div>
					<span style="margin-left: 15px; font-size: 16px">联系人</span>
				</div>

				<div class="contant">
					<span class="wid">默认群组</span>
					<div class="groupTags">
						<el-radio-group style="margin-left: 10px;" v-model="searchFrom.contactsFilters.condition" @change="changeCondition">
							<el-radio :label="1">所有联系人</el-radio>
							<el-radio :label="0">未分组联系人</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="contant">
					<span class="wid">自定义群组</span>
					<div class="groupTags">
						<div v-for="item in customGroup" :key="item.id">
							<filter-label
								v-model="item.checked"
								:label="item.typeName"
								:editing="item.isediting"
								:isNew="item.isNew"
								@isEditingChange="(val) => item.isediting = val"
								@del="() => deleteContactsType(item)"
								@labelChange="name => updateContactsType(item, name)"
								@statusChange="value => searchGroupTags(item, value)"
							></filter-label>
						</div>
						<div v-if="isAddGroup" style="margin-left: 10px">
							<el-input size="mini" v-model="groupInfo.typeName">
								<el-button slot="append" title="确认" icon="el-icon-check" @click="confirmGroup"></el-button>
							</el-input>
						</div>
						<el-button style="margin-left: 10px;" size="mini" @click="isAddGroup = true">+添加群组</el-button>
					</div>
				</div>
				<div class="contant">
					<span class="wid">最近联系时间</span>
					<div class="groupTags">
						<el-radio-group style="margin-left: 10px;" v-model="searchFrom.contactsFilters.recent" @change="changeRecent">
							<el-radio v-for="(item, index) in contactTime" :key="index" :label="item.value">{{ item.label }}</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="contant">
					<span class="wid">标签</span>
					<div class="groupTags">
						<div v-for="item in tagList" :key="item.id">
							<filter-label
								v-model="item.checked"
								:label="item.typeName"
								:isNew="item.isNew"
								:editing="item.isediting"
								@isEditingChange="(val) => item.isediting = val"
								@del="() => deleteContactsType(item)"
								@labelChange="name => updateContactsType(item, name)"
								@statusChange="value => searchGroupTags(item, value)"
							></filter-label>
						</div>
						<div v-if="isAddTag" style="margin-left: 10px">
							<el-input size="mini" v-model="tagInfo.typeName">
								<el-button slot="append" title="确认" icon="el-icon-check" @click="confirmTag"></el-button>
							</el-input>
						</div>
						<el-button style="margin-left: 10px;" size="mini" @click="isAddTag = true">+添加标签</el-button>
					</div>
				</div>
				<div
					style="
            width: 1110px;
            height: 1px;
            background: #e1e1e1;
            margin-top: 20px;
          "
				></div>
				<div class="table_box">
					<div class="contant">
						<div class="bor"></div>
						<span style="margin-left: 15px; font-size: 16px">联系人列表</span>
					</div>
					<div class="search_box">
						<div class="search_left">
							<el-input size="small" placeholder="搜索联系人" v-model="searchFrom.contactsFilters.search">
								<el-button slot="append" icon="el-icon-search" @click="searchName"></el-button>
							</el-input>
						</div>
						<div class="search_right">
							<el-dropdown @command="addContantMenu" :popper-append-to-body="false">
								<el-button size="small" type="primary">
									添加联系人<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="fromExcel">从Excel文件导入</el-dropdown-item>
									<el-dropdown-item command="byHand">手动添加</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-button :disabled="totalNumber == 0" style="margin-left: 10px;" size="small"  type="primary"  @click="exportExcel">
								导出
							</el-button>
							<el-tooltip class="item" effect="light" :content="selNumber == 0 ? '勾选联系人' : '为联系人添加群组'" placement="top">
								<el-button :disabled="selNumber == 0" style="margin-left: 10px;" size="small"  type="primary"  @click="setGroup">
									设置群组<span v-if="selNumber > 0">（{{ selNumber }}）</span>
								</el-button>
							</el-tooltip>
							
							<el-tooltip class="item" effect="light" :content="selNumber == 0 ? '勾选联系人' : '为联系人添加标签'" placement="top">
								<el-button :disabled="selNumber == 0" style="margin-left: 10px;" size="small"  type="primary"  @click="setLabel">
									设置标签<span v-if="selNumber > 0">（{{ selNumber }}）</span>
								</el-button>
							</el-tooltip>
							<el-button :disabled="selNumber == 0" style="margin-left: 10px;" size="small"  type="danger"  @click="batchDeletion">
								批量删除<span v-if="selNumber > 0">（{{ selNumber }}）</span>
							</el-button>
						</div>
					</div>
					<div class="box">
						<div class="box_left">
							<span>总人数 : {{ totalNumber }}</span>
							<span style="margin-left: 40px">已选中 : {{ selNumber }}</span>
							<!-- <span style="margin-left: 40px; color: #0080ff">合并联系人</span> -->
						</div>
						<div class="box_right">
							<!-- 后期功能，暂时注释 -->
							<!-- <span
                ><i
                  class="iconfont iconlianxirenicon-07"
                  style="margin-right: 5px"
                ></i
                >发送短信</span
              >
              <span style="margin-left: 40px"
                ><i
                  class="iconfont iconlianxirenicon-08"
                  style="margin-right: 5px"
                ></i
                >发送邮件</span
              > -->
						</div>
					</div>

					<!-- 联系人列表下table表格 -->
					<div class="" style="margin-top: 10px">
						<el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
							<el-table-column type="selection" width="54" align="center"></el-table-column>
							<el-table-column prop="name" label="姓名" width="100" align="center">
							</el-table-column>
							<el-table-column label="邮箱" width="200" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.email !== ''">{{ scope.row.email }}</span>
									<span v-else>暂无</span>
								</template>
							</el-table-column>
							<el-table-column label="手机" width="120" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.cellphone !== ''">{{ scope.row.cellphone }}</span>
									<span v-else>暂无</span>
								</template>
							</el-table-column>
							<el-table-column prop="groups" label="群组" width="200" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.groupList.length">{{ displayGroupTag(scope.row.groupList) }}</span>
									<span v-else>暂无</span>
								</template>
							</el-table-column>
							<el-table-column prop="tags" label="标签" width="200" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.tagList.length">{{ displayGroupTag(scope.row.tagList) }}</span>
									<span v-else>暂无</span>
								</template>
							</el-table-column>
							<el-table-column prop="company" label="公司" width="200" align="center">
								<template slot-scope="scope">
									<span v-if="scope.row.company !== ''">{{ scope.row.company }}</span>
									<span v-else>暂无</span>
								</template>
							</el-table-column>
							<el-table-column fixed="right" prop="company" label="操作" width="100" align="center">
								<template slot-scope="scope">
									<el-button @click="addConIsTure(scope.row)" type="text">编辑</el-button>
									<el-button @click="delectabl(scope.row.id)" type="text">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination
								@current-change="currentPage"
								:hide-on-single-page="page_value"
								:current-page.sync="one_page.currentPageIndex"
								:page-size="one_page.pageSize"
								:total="one_page.totals"
								class="fr"
								background
								layout="prev, pager, next, jumper"
							></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>


		<!-- 编辑群组，标签 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible"  width="30%" :close-on-click-modal="false">
			<div class="dialog-content">
				<div class="dialog-content-list">
					<div v-for="item in dialogModel" :key="item.id">
						<filter-label
							v-model="item.checked"
							:label="item.typeName"
							:isNew="item.isNew"
							:editing="item.isediting"
							:indeterminate="item.indeterminate"
							@isEditingChange="(val) => item.isediting = val"
							@del="() => deleteContactsType(item)"
							@labelChange="name => updateContactsType(item, name)"
						></filter-label>
					</div>
					<div v-if="dialogGroups" style="margin-left: 10px">
						<el-input size="mini" v-model="groupInfo.typeName">
							<el-button slot="append" title="确认" icon="el-icon-check" @click="confirmGroup"></el-button>
						</el-input>
					</div>
					<div v-if="dialogTags" style="margin-left: 10px">
						<el-input size="mini" v-model="tagInfo.typeName">
							<el-button slot="append" title="确认" icon="el-icon-check" @click="confirmTag"></el-button>
						</el-input>
					</div>
				</div>
				<el-button v-if="dialogTitle == '编辑群组'" size="mini" @click="dialogGroups = true">+添加群组</el-button>
				<el-button v-else size="mini" @click="dialogTags = true">+添加标签</el-button>
				
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="cancelSetContactsGroupAndTags">取 消</el-button>
				<el-button size="mini" type="primary" @click="setContactsGroupAndTags">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 导入联系人弹框 -->
		<el-dialog title="从文件导入联系人" :visible.sync="dialogImport" width="30%" :close-on-click-modal="false">
			<div class="files">
				<el-button class="file" size="small" type="primary" >
					上传Excel格式文件
					<input type="file" name="" id="" @change="importFile"/>
				</el-button>
				
				<el-button type="text" @click="downloadFile">下载示例模板</el-button>
			</div>
		</el-dialog>
		
		<!-- 添加联系人 -->
		<el-dialog :title="addContactTitle" :visible.sync="addContactVisible" @close="cancelAddContact('ruleFormAddContact')"  width="800px" :close-on-click-modal="false">
			<el-form :model="form" :rules="rulesAddContact" ref="ruleFormAddContact" label-width="100px" class="demo-ruleForm">
				<el-form-item prop="name" label="姓名：" >
					<el-input size="small" :show-word-limit="true" :maxlength="15" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="邮箱：" prop="email">
					<el-input  size="small" v-model="form.email" style="float: left"></el-input>
				</el-form-item>
				<el-form-item label="手机：" prop="phone">
					<el-input  size="small" v-model="form.phone"></el-input>
				</el-form-item>
				<el-form-item prop="birthday" label="生日：">
					<el-date-picker :append-to-body="false" size="small" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.birthday" type="date" :editable="false"></el-date-picker>
				</el-form-item>
				<el-form-item prop="sex" label="性别：">
					<el-select :popper-append-to-body="false" size="small" v-model="form.sex" placeholder="请选择">
						<el-option label="男" :value="1"></el-option>
						<el-option label="女" :value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="公司：" prop="company">
					<el-input  size="small" v-model="form.company"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="cancelAddContact('ruleFormAddContact')">取 消</el-button>
				<el-button size="small" type="primary" @click="submitFormAddContact('ruleFormAddContact')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
import FilterLabel from '@/components/contant/FilterLabel';
export default {
	data() {
		var validatephone = (rule, value, callback) => {
			let regphone = /^1[3456789]\d{9}$/;
			
			if (value === '') {
				callback(new Error('手机号不能为空！'));
			} else if (!regphone.test(value)) {
				callback(new Error('手机号不正确！'));
			} else {
				callback();
			}
		};
		return {
			dialogTitle: '编辑群组',
			dialogVisible: false,
			dialogGroups: false,
			dialogTags: false,
			dialogImport: false,
			dialogModel: [],
			checkeds: '',
			isAddGroup: false,
			isAddTag: false,
			groupInfo: {
				id: Date.now(),
				isNew: true,
				isediting: true,
				checked: false,
				state: 0,
				indeterminate: false,
				typeName: ''
			},
			tagInfo: {
				id: Date.now(),
				isNew: true,
				isediting: true,
				checked: false,
				state: 1,
				indeterminate: false,
				typeName: ''
			},
			groupList: [],
			tagList: [],
			check: '',
			checked: '',
			input: '',
			tableData: [],
			multipleSelection: [],
			totalNumber: 0,
			selNumber: 0,
			contant: true,
			addCon: false,
			editConVisibility: false,
			editCon: false,
			form: {
				id: '',
				name: '',
				birthday: '',
				sex: 0,
				email: '',
				company: '',
				phone: '',
			},
			searchFrom: {
				contactsFilters: {
					condition: '',
					contactsId: '',
					groups: [],
					recent: '',
					search: '',
					state: 0,
					tags: []
				},
				pageIndex: 1,
				pageSize: 10
			},
			page_value: false,
			one_page: {
				// 分页
				currentPageIndex: 1, //当前第几页
				totals: 0, //总共多少条数据
				pageSize: 10 //一页显示几个
			},
			provArr: [],
			cityArr: [],
			countyArr: [],
			contactTime: [
				{
					label: '一天内',
					value: 0,
					checked: false
				},
				{
					label: '一周内',
					value: 1,
					checked: false
				},
				{
					label: '一月内',
					value: 2,
					checked: false
				},
				{
					label: '一年内',
					value: 3,
					checked: false
				}
			],
			addContactVisible: false,
			addContactTitle: '添加联系人',
			rulesAddContact: {
				name: [
					{ required: true, message: '请输入联系人姓名', trigger: 'blur' }
				],
				birthday: [
					{ required: false }
				],
				sex: [
					{ required: false }
				],
				email: [
					{ required: true, message: '请输入邮箱地址', trigger: 'blur' },
					{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
				],
				company: [
					{ required: false }
				],
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' },
					{ validator: validatephone, trigger: ['blur', 'change'] }
				],
			}
		};
	},
	computed: {
		defaultGroup() {
			if (this.groupList.length >= 2) {
				return [this.groupList[0], this.groupList[1]];
			}
			return [];
		},
		customGroup() {
			if (this.groupList.length > 2) {
				var _list = [];
				for (let i = 2; i < this.groupList.length; i++) {
					_list.push(this.groupList[i]);
				}
				return _list;
			}
			return [];
		},
		// selectedIds(){

		// },
		statusGroup() {
			let selection_count = this.multipleSelection.length;
			return this.customGroup.map(item => {
				let count = 0;
				for (contant of this.multipleSelection) {
					if (contant.groups.split(',').includes(item.id)) {
						count++;
					}
				}
				if (count == 0) {
					item.edit_status = 0;
				} else if (count == selection_count) {
					item.edit_status = 1;
				} else {
					item.edit_status = 2;
				}
				return item;
			});
		},
	},
	components: {
		SecondHead,
		FilterLabel
	},
	mounted() {},
	created() {
		this.queryContactsType();
		this.queryContacts();
		this.loadProvice();
	},
	methods: {
		submitFormAddContact(formName) {
			this.$refs[formName].validate((valid) => {
			if (valid) {
				this.saveContant(formName)
			} else {
				console.log('error submit!!');
				return false;
			}
			});
		},
		cancelAddContact(formName) {
			this.$refs[formName].resetFields();
			this.addContactVisible = false
		},
		language() {
			return window.localStorage.getItem('lang') || this.$defaultLang
		},
		//联系人列表 点击姓名编辑联系人
		addConIsTure(scopeRow) {
			this.form = {
				name: scopeRow.name,
				birthday: scopeRow.birthday,
				sex: scopeRow.sex,
				email: scopeRow.email,
				company: scopeRow.company,
				phone: scopeRow.cellphone,
				id: scopeRow.id,
			}
			this.addContactTitle = '修改联系人'
			this.addContactVisible = true
		},
		// 添加分组
		addlabel() {},
		// 添加群组确认
		confirmGroup() {
			if (this.groupInfo.typeName !== '') {
				this.groupList.push(this.groupInfo);
				this.groupList.indeterminate = false;
				this.updateContactsType(this.groupInfo, this.groupInfo.typeName);
				this.dialogModel = this.customGroup;
				this.isAddGroup = false;
				this.dialogGroups = false;
				this.groupInfo = this.$options.data().groupInfo;
			} else {
				this.$message.error('请输入群组名称');
			}
		},
		closeGroup() {
			this.groupInfo.typeName = ''
			this.isAddGroup = false;
		},
		// 添加标签确认
		confirmTag() {
			if (this.tagInfo.typeName !== '') {
				this.tagInfo.indeterminate = false;
				this.tagList.push(this.tagInfo);
				this.updateContactsType(this.tagInfo, this.tagInfo.typeName);
				this.dialogModel = this.tagList;
				this.isAddTag = false;
				this.dialogTags = false;
				this.tagInfo = this.$options.data().tagInfo;
			} else {
				this.$message.error('请输入标签名称');
			}
		},
		closeTag() {
			this.tagInfo.typeName = ''
			this.isAddTag = false;
		},
		// 删除联系人
		delectabl(id) {
			this.$confirm('确认删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let that = this;
					let params = {
						that: this,
						url: `${this.$config.service.deleteCContacts}`,
						method: 'post',
						data: {
							id: id
						},
						cb(res) {
							if (res.code == 0) {
								that.comeback();
								that.queryContacts();
								that.$message({
									type: 'success',
									message: '删除成功!'
								});
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		// 新增联系人
		saveContant(formName) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.save}`,
				method: 'post',
				data: {
					birthday: that.form.birthday,
					cellphone: that.form.phone,
					company: that.form.company,
					email: that.form.email,
					id: that.form.id,
					name: that.form.name,
					sex: that.form.sex,
				},
				cb(res) {
					if (res.code == 0) {
						that.cancelAddContact(formName)
						that.queryContacts();
						console.log('保存联系人', res);
					}
				}
			};
			this.$util.request(params);
		},
		removeAddress(item) {
			var index = this.form.child4.indexOf(item);
			if (index !== -1) {
				this.form.child4.splice(index, 1);
			}
		},
		addRess() {
			this.form.child4.push({
				province: '',
				city: '',
				county: '',
				key: Date.now()
			});
		},
		removephone(item) {
			var index = this.form.child3.indexOf(item);
			if (index !== -1) {
				this.form.child3.splice(index, 1);
			}
		},
		addphone() {
			this.form.child3.push({
				phone: '',
				key: Date.now()
			});
		},
		removeCompany(item) {
			var index = this.form.child2.indexOf(item);
			if (index !== -1) {
				this.form.child2.splice(index, 1);
			}
		},
		addDCompany() {
			this.form.child2.push({
				company: '',
				key: Date.now()
			});
		},
		removeDomain(item) {
			var index = this.form.child.indexOf(item);
			if (index !== -1) {
				this.form.child.splice(index, 1);
			}
		},
		addDomain() {
			this.form.child.push({
				email: '',
				key: Date.now()
			});
		},
		//添加联系人菜单
		addContantMenu(command) {
			//手动添加
			if (command == 'byHand') {
				this.addContant();
			}
			//从Excel中导入
			if (command == 'fromExcel') {
				this.dialogImport = true;
			}
		},
		importFile(event) {
			let file = event.target.files[0];
			let formData = new FormData();
			formData.append('multipartFile', file);
			console.log(event);
			console.log(file);
			console.log(formData);
			let that = this;
			that.$axios({
				url: this.$config.service.importContacts,
				method: 'POST',
				headers: {
					'Content-Type': 'multipart/form-data',
					Authorization: 'Bearer ' + window.localStorage.getItem('token'),
                    'Accept-Language': this.language(),
				},
				data: formData
			}).then(res => {
				if (res.data.code == 0) {
					this.queryContacts();
					that.$message.success('导入成功');
					that.dialogImport = false;
				} else {
					that.$message.error('导入失败，请重新导入');
					that.dialogImport = false;
				}
			});
		},
		// 下载模板
		downloadFile() {
			this.$axios({
				method: 'get',
				url: './template/联系人导入模板.xlsx',
				responseType: 'blob',
                headers:{
                    'Accept-Language': this.language(),
                },
			}).then(response => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				let fname = '联系人导入模板.xlsx';
				link.href = url;
				link.setAttribute('download', fname);
				document.body.appendChild(link);
				link.click();
				this.dialogImport = false;
			});
		},
		// 导出联系人
		exportExcel() {
			let that = this;
			that.$axios({
				url: this.$config.service.exportContact,
				method: 'POST',
				responseType: 'blob',
				headers: {
					// 'Content-Type': 'multipart/form-data',
					Authorization: 'Bearer ' + window.localStorage.getItem('token'),
					'Accept-Language': this.language(),
				},
				data: this.searchFrom
			}).then(res => {
				const link = document.createElement('a');
				let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }); //生成blob对象
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '联系人列表.xls'); //下载的文件名以及文件格式
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				that.dialogImport = false;
			});
		},
		addContant() {
			this.addContactTitle = '添加联系人'
			this.addContactVisible = true
		},
		// 返回联系人列表
		comeback() {
			this.contant = true;
			this.addCon = false;
			this.editConVisibility = false;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.selNumber = this.multipleSelection.length;
		},
		// 默认群组查询
		changeCondition(value) {
			this.searchFrom.contactsFilters.condition = value;
			this.queryContacts(this.searchFrom);
		},
		// 群组标签查询
		searchGroupTags(itemId, value) {
			let groupArr = [];
			let tagArr = [];
			if (itemId.state == 0 && value) {
				// 群组选中
				groupArr.push(itemId.id);
			} else if (itemId.state == 1 && value) {
				// 标签选中
				tagArr.push(itemId.id);
			} else if (itemId.state == 0 && !value) {
				// 群组取消
				groupArr.splice(groupArr.indexOf(itemId.id), 1);
			} else if (itemId.state == 1 && !value) {
				// 标签取消
				tagArr.splice(tagArr.indexOf(itemId.id), 1);
			}
			this.searchFrom.contactsFilters.groups = groupArr;
			this.searchFrom.contactsFilters.tags = tagArr;
			this.queryContacts(this.searchFrom);
		},
		// 最近联系时间查询
		changeRecent(value) {
			this.searchFrom.contactsFilters.recent = value;
			this.queryContacts(this.searchFrom);
		},
		// 联系人姓名搜索
		searchName() {
			this.queryContacts(this.searchFrom);
		},
		// 表格分页
		currentPage(val) {
			let that = this;
			that.one_page.currentPageIndex = val;
			that.searchFrom.pageIndex = val;
			that.queryContacts(that.searchFrom);
		},
		// 查询联系人
		queryContacts(data) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryContactsLoad}`,
				method: 'post',
				data: { ...data },
				cb(res) {
					if (res.code == 0) {
						that.tableData = res.resultBody.datas;
						that.totalNumber = res.resultBody.total;
						that.one_page.currentPageIndex = res.resultBody.pageIndex;
						that.one_page.pageSize = res.resultBody.pageSize;
						that.one_page.totals = res.resultBody.total;
						console.log('查询所有联系人', res);
					} else {
						that.tableData = [];
						that.totalNumber = 0;
					}
				}
			};
			this.$util.request(params);
		},
		cancelSetContactsGroupAndTags() {
			this.groupInfo.typeName = ''
			this.tagInfo.typeName = ''
			this.dialogGroups = false
			this.dialogTags = false
			this.dialogVisible = false
		},
		// 设置联系人群组/标签
		setContactsGroupAndTags() {
			let ids = [];
			let groups = [];
			let tags = [];
			this.multipleSelection.map(item => {
				ids.push(item.id);
			});
			this.customGroup.map(item => {
				if (item.checked && !item.indeterminate) {
					// 选中
					groups.push({ id: item.id, value: 1 });
				} else if (!item.checked && item.indeterminate) {
					// 半选
					groups.push({ id: item.id, value: 2 });
				} else if (!item.checked && !item.indeterminate) {
					// 清空
					groups.push({ id: item.id, value: 0 });
				}
			});
			this.tagList.map(item => {
				if (item.checked && !item.indeterminate) {
					// 选中
					tags.push({ id: item.id, value: 1 });
				} else if (!item.checked && item.indeterminate) {
					// 半选
					tags.push({ id: item.id, value: 2 });
				} else if (!item.checked && !item.indeterminate) {
					// 清空
					tags.push({ id: item.id, value: 0 });
				}
			});

			if (ids.length !== 0) {
				let that = this;
				if (this.dialogTitle == '编辑群组') {
					let params = {
						that: this,
						url: `${this.$config.service.setContactsType}`,
						method: 'post',
						data: {
							contactsIds: ids,
							groupTagsList: groups,
							type: 0
						},
						cb(res) {
							if (res.code == 0) {
								console.log('设置联系人群组', res);
								that.queryContacts();
								that.cancelSetContactsGroupAndTags()
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					let params = {
						that: this,
						url: `${this.$config.service.setContactsType}`,
						method: 'post',
						data: {
							contactsIds: ids,
							groupTagsList: tags,
							type: 1
						},
						cb(res) {
							if (res.code == 0) {
								console.log('设置联系人标签', res);
								that.queryContacts();
								that.cancelSetContactsGroupAndTags()
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				}
			}
		},
		// 查询所有群组 ,标签
		queryContactsType() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryContactsType}`,
				method: 'post',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.groupList = res.resultBody.groupList.map(function(item) {
							item.isNew = false;
							item.isediting = false;
							item.checked = false;
							item.indeterminate = false;
							return item;
						});
						that.tagList = res.resultBody.tagList.map(function(item) {
							item.isNew = false;
							item.isediting = false;
							item.checked = false;
							item.indeterminate = false;
							return item;
						});
						console.log('查询所有群组 ,标签', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 获取市
		queryProv(val) {
			console.log('输出市和县的内容', val);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryLinkage}`,
				method: 'post',
				data: {
					id: val
				},
				cb(res) {
					if (res.code == 0) {
						that.cityArr = res.resultBody.datas;
						console.log('获取市的数据', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 获取县
		queryCounty(val) {
			console.log('输出市和县的内容', val);
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryLinkage}`,
				method: 'post',
				data: {
					id: val
				},
				cb(res) {
					if (res.code == 0) {
						that.countyArr = res.resultBody.datas;
						console.log('获取县的数据', res);
					}
				}
			};
			this.$util.request(params);
		},
		// 获取省
		loadProvice() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryProvince}`,
				method: 'post',
				data: {},
				cb(res) {
					if (res.code == 0) {
						that.provArr = res.resultBody.datas;
						// console.log("获取省的数据", res);
					}
				}
			};
			this.$util.request(params);
		},
		beforeContactsTypeAddOrUpdate(item, name) {
			let group = item.state == 0 ? this.groupList : this.tagList;
			let type = item.state == 0 ? '群组' : '标签';
			let index = group.indexOf(item);
			for (let i = 0; i < group.length; i++) {
				if (index != i && name == group[i].typeName) {
					this.$message({
						type: 'info',
						message: `${type}“${name}”已存在`
					});
					return false;
				}
			}
			item.isediting = false
			return true;
		},
		// 添加标签/组
		addContactsType(item) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.addContactsType}`,
				method: 'post',
				data: {
					state: item.state,
					typeName: item.typeName
				},
				cb(res) {
					if (res.code == 0) {
						that.isAddGroup = false;
						//that.queryContactsType();
						console.group('添加标签/组');
						console.log('res', res);
						console.groupEnd();
						that.$set(item, 'id', res.resultBody.id);
						that.$set(item, 'isNew', false);
						that.$set(item, 'isediting', false);
						that.$set(item, 'createTime', res.resultBody.createTime);
						that.$set(item, 'createId', res.resultBody.createId);
					}
				}
			};
			this.$util.request(params);
		},
		//删除组、标签
		deleteContactsType(item) {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.deleteContactsType}`,
				method: 'post',
				data: {
					id: item.id
				},
				cb(res) {
					if (res.code == 0) {
						//that.queryContactsType();
						console.group('删除组、标签');
						console.log('res', res);
						console.groupEnd();
						if (item.state == 1) {
							that.tagList.splice(that.tagList.indexOf(item), 1);
							that.dialogModel.splice(that.dialogModel.indexOf(item), 1);
						} else if (item.state == 0) {
							that.groupList.splice(that.groupList.indexOf(item), 1);
							that.dialogModel.splice(that.dialogModel.indexOf(item), 1);
						}
					}
				}
			};
			this.$util.request(params);
		},
		//修改组、标签
		updateContactsType(item, name) {
			if (!this.beforeContactsTypeAddOrUpdate(item, name)) return;
			item.typeName = name;
			if (item.isNew) {
				this.addContactsType(item);
				return;
			}
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.updateContactsType}`,
				method: 'post',
				data: {
					id: item.id,
					typeName: item.typeName
				},
				cb(res) {
					if (res.code == 0) {
						console.group('修改组、标签');
						console.log('res', res);
						console.groupEnd();
						that.tagList.remove;
					}
				}
			};
			this.$util.request(params);
		},
		//删除选中联系人
		batchDeletion() {
			this.$confirm('确认删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let ids = [];
					for (let i = 0; i < this.multipleSelection.length; i++) {
						ids.push(this.multipleSelection[i].id);
					}
					if (ids.length == 0) {
						this.$message({
							type: 'error',
							message: '请选择联系人！'
						});
					} else {
						let that = this;
						let params = {
							that: this,
							url: `${this.$config.service.deleteCContacts}`,
							method: 'post',
							data: {
								id: ids.join(',')
							},
							cb(res) {
								if (res.code == 0) {
									that.$message({
										type: 'success',
										message: '删除成功!'
									});
									that.queryContacts();
								} else {
									that.$message.error(res.message);
								}
							}
						};
						this.$util.request(params);
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		//编辑选中联系人的群组
		setGroup() {
			this.dialogModel = [];
			this.dialogModel = this.customGroup;
			this.searchContactsGroupTags(this.dialogModel, 0, '编辑群组');
		},
		//编辑选中联系人的标签
		setLabel() {
			this.dialogModel = [];
			this.dialogModel = this.tagList;
			this.searchContactsGroupTags(this.dialogModel, 1, '编辑标签');
		},
		// 查询联系人群组/标签
		searchContactsGroupTags(arr, type, title) {
			if (this.multipleSelection.length !== 0) {
				let idArr = [];
				this.multipleSelection.map(item => {
					idArr.push(item.id);
				});
				let that = this;
				let params = {
					that: this,
					url: `${this.$config.service.queryContactsGroupTags}?ids=${idArr.join(',')}&type=${type}`,
					method: 'get',
					cb(res) {
						if (res.code == 0) {
							arr.map(val => {
								val.checked = false;
								val.indeterminate = false;
								res.resultBody.datas.map(item => {
									if (item.id == val.id && item.value == idArr.length) {
										// 选中状态
										val.checked = true;
										val.indeterminate = false;
									} else if (item.id == val.id && item.value != idArr.length) {
										// 半选状态
										val.checked = false;
										val.indeterminate = true;
									} else if (item.id == val.id) {
										// 清空
										val.checked = false;
										val.indeterminate = false;
									}
								});
							});
							that.dialogTitle = title;
							that.dialogVisible = true;
							return arr;
						} else if (res.code == 1001) {
							that.dialogTitle = title;
							that.dialogVisible = true;
							return arr;
						} else {
							that.dialogTitle = title;
							that.dialogVisible = true;
							that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			} else {
				this.dialogVisible = false;
				this.$message.error('未选择联系人');
			}
		},
		//联系人表格中根据群组或标签id，转为分号分割的名称字符串
		displayGroupTag(arrList) {
			let arr = [];
			arrList.map(item => {
				arr.push(item.typeName);
			});
			return arr.join(',');
		}
	}
};
</script>

<style scoped lang="scss">
/deep/.address .el-input__inner {
	width: 130px !important;
}
/deep/.formBox .el-input__inner {
	width: 300px !important;
}
/deep/.el-popper{
	top: auto !important;
}
.formBox {
	width: 450px;
	height: auto;
}
.comeback {
	padding-top: 26px;
	padding-left: 26px;
	cursor: pointer;
}
.fill {
	width: 1200px;
	height: auto;
	background: #ffffff;
	margin: 0 auto;
	margin-top: 30px;
}
/deep/.search_left .el-input__inner {
	border: 1px solid #cccccc;
}
.contacts {
	width: 100%;
	height: auto;
	background: #f5f5f5;
	.label {
	}
}
.contacts_box {
	width: 1200px;
	height: auto;
	background: #fff;
	margin: 0 auto;
	margin-top: 30px;
}
.contacts_childOne {
	width: 1110px;
	height: auto;
	margin: 0 auto;
	padding-top: 30px;
    padding-bottom: 40px;
    min-height: calc(100vh - 161px);
}
.contant {
	display: flex;
	justify-content: left;
	align-items: center;
	line-height: 35px;
	.wid {
		display: flex;
		width: 100px;
		min-width: 100px;
		height: 100%;
		font-size: 14px;
		color: #333;
	}
	.groupTags {
		display: flex;
		align-items: baseline;
		flex-wrap: wrap;
		line-height: 35px;
	}
}
.bor {
	width: 4px;
	height: 20px;
	background-color: #0080ff;
	border-radius: 2px;
}

.contentItem {
	margin-left: 100px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}
.search_box {
	display: flex;
	justify-content: space-between;
	// height: 40px;
	align-items: center;
	margin-top: 20px;
}
.search_right {
	/* margin-right: 40px; */
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.box {
	display: flex;
	height: 30px;
	align-items: center;
	margin-top: 10px;
	justify-content: space-between;
	font-size: 14px;
}
.table_contacts_name:hover {
	color: #2191ff;
	text-decoration: underline;
}
.dialog-content-list > div {
	padding: 10px;
}
.dialog-content-list{
	height: 400px;
	overflow-y: scroll;
}
.pagination {
	padding: 10px;
	text-align: center;
}
.file{
	span{
		display: inline-block;
		position: relative;
	}
	input {
		cursor: pointer;
		width: 133.34px;
		height: 32px;
		position: absolute;
		font-size: 100px;
		left: 20px;
		top: 85px;
		opacity: 0;
	}
} 
</style>
